export default __webpack_public_path__ + "static/media/Aura-Egg__49.b473ff72.png";